import React from 'react';
import { FONT_FAMILY } from '../utils/fonts';

/**
 * DOM-BASED TEXT OVERLAY
 * Uses CSS for proper text rendering with Google Fonts
 * Browsers render Malayalam, Hindi, Tamil correctly with CSS
 * NO CANVAS - Pure DOM/CSS for preview
 */
const TextOverlay = ({
  textLayers = [],
  currentTime = null,
  isDragging = false,
  onTextClick,
  onBackgroundClick
}) => {
  // Filter visible layers for video timeline
  const visibleLayers = textLayers.filter(layer => {
    if (currentTime === null) return true; // Image mode - all visible
    return currentTime >= (layer.startTime || 0) && currentTime <= (layer.endTime || Infinity);
  });

  const handleClick = (e, layerIndex) => {
    e.stopPropagation();
    if (onTextClick) {
      onTextClick(e, layerIndex);
    }
  };

  const handleBackgroundClick = (e) => {
    if (onBackgroundClick) {
      onBackgroundClick(e);
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'auto',
        cursor: isDragging ? 'grabbing' : 'default'
      }}
      onClick={handleBackgroundClick}
    >
      {visibleLayers.map((layer, index) => {
        const textStyle = {
          position: 'absolute',
          left: `${layer.x}%`,
          top: `${layer.y}%`,
          transform: 'translate(-50%, -50%)',
          fontSize: `${layer.fontSize}px`,
          lineHeight: '1.2', // Match canvas rendering line spacing
          fontFamily: FONT_FAMILY, // Universal fallback chain from fonts.js
          fontWeight: layer.bold ? 'bold' : 'normal',
          fontStyle: layer.italic ? 'italic' : 'normal',
          color: layer.color,
          textAlign: layer.align || 'center',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word',
          maxWidth: '70%',
          cursor: isDragging ? 'grabbing' : 'grab',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          pointerEvents: 'auto',
          // CRITICAL: These CSS properties enable proper text shaping for Indic scripts
          fontFeatureSettings: '"liga" 1, "calt" 1, "kern" 1',
          textRendering: 'optimizeLegibility',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale'
        };

        return (
          <div
            key={layer.id || index}
            style={textStyle}
            onMouseDown={(e) => handleClick(e, index)}
            onTouchStart={(e) => handleClick(e, index)}
          >
            {layer.text}
          </div>
        );
      })}
    </div>
  );
};

export default TextOverlay;
